// import { error } from "ajv/dist/vocabularies/applicator/dependencies";
// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";

// const ProductCreate = () => {
//   const navigate = useNavigate();

//   const sellerId = localStorage.getItem("seller_id");


//   const initialFormState = {
//     // Basic product fields
//     product_name: "",
//     current_price: "",
//     old_price: "",
//     prod_stock: "",
//     rating: "",
//     description: "",
//     product_details: "",
//     prod_vendor_assign: "",
//     prod_size: "",
//     status: "",
//     discount_id: "",
//     discount: "",
//     paid_promo: "",
//     paid_approval: "",
//     product_status: "",
    
//     brand_id: "",

//     // Category selectors
//     main_category: "",
//     sub_category: "",
//     size_id: [],

//     // Electronics fields
//     company_name: "",
//     model_name: "",
//     ram: "",
//     rom: "",
//     processor: "",
//     camera: "",
//     battery: "",
//     operating_system: "",
//     available_colors: [],
//     weight: "",
//     dimension: "",

//     // Fashion fields
//     fashion_brand_name: "",
//     material: "",
//     fit_type: "",
//     occasion: "",
//     available_size: [],
//     available_color: [],
//     care_instructions: "",

//     // images
//     prod_image: null,
//     prod_multi_images: [],
//   };

//   const [ProductUser, setProductUser] = useState(initialFormState);
//   const [previewImage, setPreviewImage] = useState(null);
//   const [multiPreview, setMultiPreview] = useState([]);
//   const [CategoryUser, setCategoryUser] = useState([]);
//   const [SubCategoryUser, setSubCategoryUser] = useState([]);
//   const [Sizeuser, setSizeUser] = useState([]);
//   const [ColorUser, setColorUser] = useState([]);
//   const [DiscountUser, setDiscountUser] = useState([]);
//   const [BrandUser, setBrandUser] = useState([]); // Added brand state
//   const [isSizeDropdownOpen, setIsSizeDropdownOpen] = useState(false);
//   const [isColorDropdownOpen, setIsColorDropdownOpen] = useState(false);
//   const [isDiscountDropdownOpen, setIsDiscountDropdownOpen] = useState(false);
//   const [isBrandDropdownOpen, setIsBrandDropdownOpen] = useState(false); // Added brand dropdown state

//   // Generic input handler
//   const handleInput = (e) => {
//     const { name, value } = e.target;
//     setProductUser((prev) => ({ ...prev, [name]: value }));
//   };

//   // Handle multi-select arrays
//   const handleMultiSelect = (e, stateKey) => {
//     const selected = Array.from(e.target.selectedOptions, (opt) => opt.value);
//     setProductUser((prev) => ({ ...prev, [stateKey]: selected }));
//   };

//   const handleSizeCheckbox = (sizeId) => {
//     setProductUser((prev) => {
//       const currentSizes = prev.size_id || [];
//       const sizeIdStr = String(sizeId);

//       let updatedSizes;
//       if (currentSizes.includes(sizeIdStr)) {
//         updatedSizes = currentSizes.filter((id) => id !== sizeIdStr);
//       } else {
//         updatedSizes = [...currentSizes, sizeIdStr];
//       }

//       return {
//         ...prev,
//         size_id: updatedSizes,
//         available_size: updatedSizes
//       };
//     });
//   };

//   const handleColorCheckbox = (colorId) => {
//     setProductUser((prev) => {
//       const currentColors = prev.available_color || [];
//       const colorIdStr = String(colorId);

//       if (currentColors.includes(colorIdStr)) {
//         return {
//           ...prev,
//           available_color: currentColors.filter((id) => id !== colorIdStr)
//         };
//       } else {
//         return {
//           ...prev,
//           available_color: [...currentColors, colorIdStr]
//         };
//       }
//     });
//   };

//   // Handle brand radio selection
//   const handleBrandRadio = (brandId) => {
//     setProductUser((prev) => ({
//       ...prev,
//       brand_id: String(brandId)
//     }));
//   };

//   // Handle multiple images
//   const handleMultiImageChange = async (e) => {
//     const files = Array.from(e.target.files || []);
//     const validFiles = [];
//     const previews = [];

//     for (let file of files) {
//       const info = await validateImage(file);

//       if (!info.isSquare) {
//         toast.warning(
//           `${file.name} is ${info.width}×${info.height}. Image will be auto-adjusted.`
//         );
//       }

//       validFiles.push(file);
//       previews.push(URL.createObjectURL(file));
//     }

//     setProductUser((prev) => ({ ...prev, prod_multi_images: validFiles }));
//     setMultiPreview(previews);
//   };


//   const validateImage = (file) => {
//     return new Promise((resolve, reject) => {
//       const img = new Image();
//       img.src = URL.createObjectURL(file);

//       img.onload = () => {
//         const isSquare = img.width === img.height;
//         resolve({
//           width: img.width,
//           height: img.height,
//           isSquare
//         });
//       };

//       img.onerror = () => reject("Invalid image");
//     });
//   };


//   // Fetch categories
//   useEffect(() => {
//     const fetchCategories = async () => {
//       try {
//         const res = await axios.get(
//           "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_category"
//         );
//         setCategoryUser(res.data?.row || []);
//       } catch (err) {
//         console.error("Error fetching categories:", err);
//       }
//     };
//     fetchCategories();
//   }, []);

//   useEffect(() => {
//     const fetchSize = async () => {
//       try {
//         const response = await axios.get(
//           "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_mst_prod_size"
//         );
//         setSizeUser(response.data?.row || []);
//       } catch (err) {
//         console.error("Error fetching Sizes:", err);
//       }
//     };
//     fetchSize();
//   }, []);

//   useEffect(() => {
//     const fetchColour = async () => {
//       try {
//         const response = await axios.get(
//           "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_mst_prod_color"
//         );
//         setColorUser(response.data?.colors || []);
//       } catch (err) {
//         console.error("Error fetching Colours:", err);
//       }
//     };
//     fetchColour();
//   }, []);

//   useEffect(() => {
//     const fetchDiscount = async () => {
//       try {
//         const response = await axios.get(
//           "https://cyberathon.com/multivendor/index.php/Api/Master_controller/discount_list"
//         );
//         setDiscountUser(response.data?.data || []);
//       } catch (err) {
//         console.error("Error fetching Discounts:", err);
//       }
//     };
//     fetchDiscount();
//   }, []);

//   // Fetch brands
//   useEffect(() => {
//     const fetchBrands = async () => {
//       try {
//         const response = await axios.get(
//           "https://cyberathon.com/multivendor/index.php/Api/Master_controller/Brand_list"
//         );
//         setBrandUser(response.data?.data || []);
//       } catch (err) {
//         console.error("Error fetching Brands:", err);
//       }
//     };
//     fetchBrands();
//   }, []);

//   useEffect(() => {
//     const fetchSubcategories = async () => {
//       if (!ProductUser.main_category) {
//         setSubCategoryUser([]);
//         return;
//       }
//       try {
//         const res = await axios.get(
//           "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_subcategory"
//         );
//         const all = res.data?.row || [];
//         const filtered = all.filter(
//           (sub) => String(sub.category_id) === String(ProductUser.main_category)
//         );
//         setSubCategoryUser(filtered);
//       } catch (err) {
//         console.error("Error fetching subcategories:", err);
//       }
//     };
//     fetchSubcategories();
//   }, [ProductUser.main_category]);

//   const submitForm = async (e) => {
//     e.preventDefault();

//     try {
//       const formData = new FormData();

//       formData.append("seller_id", sellerId);
//       formData.append("product_name", (ProductUser.product_name || "").trim());
//       formData.append("current_price", (ProductUser.current_price || "").trim());
//       formData.append("old_price", (ProductUser.old_price || "").trim());
//       formData.append("stock", (ProductUser.prod_stock || "").trim());
//       formData.append("rating", (ProductUser.rating || "").trim());
//       formData.append("description", (ProductUser.description || "").trim());
//       formData.append("product_details", (ProductUser.product_details || "").trim());
//       formData.append("assign_vendor", (ProductUser.prod_vendor_assign || "").trim());
//       formData.append("size", (ProductUser.prod_size || "").trim());
//       formData.append("weight", (ProductUser.weight || "").trim());
//       formData.append("dimension", (ProductUser.dimension || "").trim());

//       let mappedStatus = "Out of Stock";
//       if (ProductUser.status === "Instock") mappedStatus = "In Stock";
//       if (ProductUser.status === "Outofstock") mappedStatus = "Out of Stock";
//       if (ProductUser.status === "fewleft") mappedStatus = "Few Left";
//       formData.append("status", mappedStatus);

//       formData.append("product_status", ProductUser.product_status || "");
//       formData.append("paid_approval", ProductUser.paid_approval || "");
//       formData.append("category_id", ProductUser.main_category || "");
//       formData.append("subcategory_id", ProductUser.sub_category || "");
//       formData.append("brand_id", ProductUser.brand_id || ""); // Added brand_id

//       formData.append(
//         "size_id",
//         Array.isArray(ProductUser.size_id)
//           ? ProductUser.size_id.join(",")
//           : ProductUser.size_id || ""
//       );

//       formData.append("company_name", ProductUser.company_name || "");
//       formData.append("model_name", ProductUser.model_name || "");
//       formData.append("ram", ProductUser.ram || "");
//       formData.append("rom", ProductUser.rom || "");
//       formData.append("processor", ProductUser.processor || "");
//       formData.append("camera", ProductUser.camera || "");
//       formData.append("battery", ProductUser.battery || "");
//       formData.append("operating_system", ProductUser.operating_system || "");

//       formData.append("fashion_brand_name", ProductUser.fashion_brand_name || "");
//       formData.append("material", ProductUser.material || "");
//       formData.append("fit_type", ProductUser.fit_type || "");
//       formData.append("occasion", ProductUser.occasion || "");
//       formData.append(
//         "available_size",
//         Array.isArray(ProductUser.available_size)
//           ? ProductUser.available_size.join(",")
//           : ProductUser.available_size || ""
//       );
//       formData.append(
//         "available_color",
//         Array.isArray(ProductUser.available_color)
//           ? ProductUser.available_color.join(",")
//           : ProductUser.available_color || ""
//       );
//       formData.append("care_instructions", ProductUser.care_instructions || "");
//       formData.append("discount_id", ProductUser.discount_id || "");
//       formData.append("discount", ProductUser.discount || "");

//       if (Array.isArray(ProductUser.prod_multi_images) && ProductUser.prod_multi_images.length) {
//         ProductUser.prod_multi_images.forEach((file) => {
//           formData.append("multi_image[]", file);
//         });
//       }

//       const response = await axios.post(
//         "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_create_product",
//         formData,
//         {
//           headers: { "Content-Type": "multipart/form-data" },
//         }
//       );

//       const data = response.data;
//       const success =
//         data?.status === true || data?.success === "1" || data?.status === "true";

//       if (success) {
//         toast.success(data?.message || "Product added successfully!");
//         setProductUser(initialFormState);
//         setPreviewImage(null);
//         setMultiPreview([]);
//         navigate("/product-list");
//       } else {
//         toast.error(data?.message || "Failed to add product");
//       }
//     } catch (error) {
//       console.error("API Error:", error);
//       toast.error("Something went wrong!");
//     }
//   };

//   return (
//     <div className="page-content">
//       <div className="container-fluid">
//         {/* Page Title */}
//         <div className="row">
//           <div className="col-12">
//             <div className="page-title-box">
//               <h4 className="mb-0 fw-semibold">Create Product</h4>
//               <ol className="breadcrumb mb-0">
//                 <li className="breadcrumb-item">Product</li>
//                 <li className="breadcrumb-item active">Create Product</li>
//               </ol>
//             </div>
//           </div>
//         </div>

//         {/* Form Section */}
//         <div className="row">
//           <div className="col-xl-9 col-lg-8">
//             <form onSubmit={submitForm}>
//               {/* Image Upload */}
//               <div className="card mb-3">
//                 <div className="card-header">
//                   <h4 className="card-title">Add Product Photo</h4>
//                 </div>
//                 <div className="card-body">
//                   <label className="form-label text-dark">Product Multiple Images</label>
//                   <input
//                     type="file"
//                     multiple
//                     className="form-control"
//                     accept=".png,.webp"
//                     onChange={handleMultiImageChange}
//                   />

//                   <small className="text-muted d-block mt-1">
//                     Recommended image size: <b>2000 × 2000 px (1:1 square)</b><br />
//                     Supported formats: <b>.webp, .png</b><br />
//                     Background: plain or transparent<br />
//                     Max size: 500 KB per image
//                   </small>

//                   <div className="d-flex gap-2 mt-2">
//                     {multiPreview.map((p, i) => (
//                       <img
//                         key={i}
//                         src={p}
//                         alt={`multi-${i}`}
//                         className="product-preview"
//                       />
//                     ))}
//                   </div>

//                 </div>
//               </div>

//               {/* Product Info */}
//               <div className="card">
//                 <div className="card-header">
//                   <h4 className="card-title">Product Information</h4>
//                 </div>
//                 <div className="card-body">
//                   <div className="row g-3">
//                     <div className="col-lg-6">
//                       <label className="form-label">Product Name</label>
//                       <input
//                         type="text"
//                         name="product_name"
//                         value={ProductUser.product_name}
//                         onChange={handleInput}
//                         className="form-control"
//                         placeholder="Enter product name"
//                       />
//                     </div>

//                     <div className="col-lg-6">
//                       <label className="form-label">Current Price</label>
//                       <input
//                         type="number"
//                         name="current_price"
//                         value={ProductUser.current_price}
//                         onChange={handleInput}
//                         className="form-control"
//                         placeholder="000"
//                       />
//                     </div>

//                     <div className="col-lg-6">
//                       <label className="form-label">Old Price</label>
//                       <input
//                         type="number"
//                         name="old_price"
//                         value={ProductUser.old_price}
//                         onChange={handleInput}
//                         className="form-control"
//                         placeholder="000"
//                       />
//                     </div>

//                     {/* CATEGORY SELECTION */}
//                     <div className="col-lg-6">
//                       <label className="form-label">Main Category</label>
//                       <select
//                         className="form-control"
//                         name="main_category"
//                         value={ProductUser.main_category}
//                         onChange={(e) =>
//                           setProductUser((prev) => ({
//                             ...prev,
//                             main_category: e.target.value,
//                             sub_category: "",
//                           }))
//                         }
//                       >
//                         <option value="">-- Select Main Category --</option>
//                         {CategoryUser.map((item) => (
//                           <option key={item.category_id} value={String(item.category_id)}>
//                             {item.category_name}
//                           </option>
//                         ))}
//                       </select>
//                     </div>

//                     {/* SUBCATEGORY */}
//                     {ProductUser.main_category && (
//                       <div className="col-lg-6">
//                         <label className="form-label">Subcategory</label>
//                         <select
//                           className="form-control"
//                           name="sub_category"
//                           value={ProductUser.sub_category}
//                           onChange={handleInput}
//                         >
//                           <option value="">-- Select Subcategory --</option>
//                           {SubCategoryUser.map((item) => (
//                             <option key={item.subcategory_id} value={String(item.subcategory_id)}>
//                               {item.subcategory_name}
//                             </option>
//                           ))}
//                         </select>
//                       </div>
//                     )}

//                     {/* BRAND SELECTION WITH RADIO BUTTONS */}
//                     <div className="col-lg-6">
//                       <label className="form-label">Product Brand</label>
//                       <div className="position-relative">
//                         <div
//                           className="form-control d-flex justify-content-between align-items-center"
//                           style={{ cursor: "pointer" }}
//                           onClick={() => setIsBrandDropdownOpen(!isBrandDropdownOpen)}
//                         >
//                           <span>
//                             {ProductUser.brand_id
//                               ? BrandUser.find(b => String(b.brand_id) === String(ProductUser.brand_id))?.brand_name || "Select brand"
//                               : "Select brand"}
//                           </span>
//                           <span>{isBrandDropdownOpen ? "▲" : "▼"}</span>
//                         </div>

//                         {isBrandDropdownOpen && (
//                           <div
//                             className="border rounded bg-white position-absolute w-100 mt-1"
//                             style={{
//                               maxHeight: "250px",
//                               overflowY: "auto",
//                               zIndex: 1000,
//                               boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
//                             }}
//                           >
//                             <div className="p-3">
//                               {BrandUser.length > 0 ? (
//                                 BrandUser.filter(brand => brand.status === "active").map((brand) => (
//                                   <div key={brand.brand_id} className="form-check mb-2">
//                                     <input
//                                       className="form-check-input"
//                                       type="radio"
//                                       name="brand_selection"
//                                       id={`brand-${brand.brand_id}`}
//                                       checked={String(ProductUser.brand_id) === String(brand.brand_id)}
//                                       onChange={() => {
//                                         handleBrandRadio(brand.brand_id);
//                                         setIsBrandDropdownOpen(false);
//                                       }}
//                                     />
//                                     <label className="form-check-label" htmlFor={`brand-${brand.brand_id}`}>
//                                       <div className="fw-semibold">{brand.brand_name}</div>
//                                       <small className="text-muted">{brand.manuf_name}</small>
//                                     </label>
//                                   </div>
//                                 ))
//                               ) : (
//                                 <p className="text-muted mb-0">No brands available</p>
//                               )}
//                             </div>
//                           </div>
//                         )}
//                       </div>
//                     </div>

//                     {/* SIZE SELECTION WITH CHECKBOXES */}
//                     <div className="col-lg-6">
//                       <label className="form-label">Product Sizes</label>
//                       <div className="position-relative">
//                         <div
//                           className="form-control d-flex justify-content-between align-items-center"
//                           style={{ cursor: "pointer" }}
//                           onClick={() => setIsSizeDropdownOpen(!isSizeDropdownOpen)}
//                         >
//                           <span>
//                             {ProductUser.size_id && ProductUser.size_id.length > 0
//                               ? `${ProductUser.size_id.length} size(s) selected`
//                               : "Select sizes"}
//                           </span>
//                           <span>{isSizeDropdownOpen ? "▲" : "▼"}</span>
//                         </div>

//                         {isSizeDropdownOpen && (
//                           <div
//                             className="border rounded bg-white position-absolute w-100 mt-1"
//                             style={{
//                               maxHeight: "200px",
//                               overflowY: "auto",
//                               zIndex: 1000,
//                               boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
//                             }}
//                           >
//                             <div className="p-3">
//                               {Sizeuser.length > 0 ? (
//                                 Sizeuser.map((size) => (
//                                   <div key={size.size_id} className="form-check mb-2">
//                                     <input
//                                       className="form-check-input"
//                                       type="checkbox"
//                                       id={`size-${size.size_id}`}
//                                       checked={(ProductUser.size_id || []).includes(String(size.size_id))}
//                                       onChange={() => handleSizeCheckbox(size.size_id)}
//                                     />
//                                     <label className="form-check-label" htmlFor={`size-${size.size_id}`}>
//                                       {size.size_label || size.size}
//                                     </label>
//                                   </div>
//                                 ))
//                               ) : (
//                                 <p className="text-muted mb-0">No sizes available</p>
//                               )}
//                             </div>
//                           </div>
//                         )}
//                       </div>
//                     </div>

//                     {/* COLOR SELECTION WITH CHECKBOXES */}
//                     <div className="col-lg-6">
//                       <label className="form-label">Product Colors</label>
//                       <div className="position-relative">
//                         <div
//                           className="form-control d-flex justify-content-between align-items-center"
//                           style={{ cursor: "pointer" }}
//                           onClick={() => setIsColorDropdownOpen(!isColorDropdownOpen)}
//                         >
//                           <span>
//                             {ProductUser.available_color && ProductUser.available_color.length > 0
//                               ? `${ProductUser.available_color.length} color(s) selected`
//                               : "Select colors"}
//                           </span>
//                           <span>{isColorDropdownOpen ? "▲" : "▼"}</span>
//                         </div>

//                         {isColorDropdownOpen && (
//                           <div
//                             className="border rounded bg-white position-absolute w-100 mt-1"
//                             style={{
//                               maxHeight: "200px",
//                               overflowY: "auto",
//                               zIndex: 1000,
//                               boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
//                             }}
//                           >
//                             <div className="p-3">
//                               {ColorUser.length > 0 ? (
//                                 ColorUser.map((color) => (
//                                   <div key={color.color_id} className="form-check mb-2 d-flex align-items-center">
//                                     <input
//                                       className="form-check-input"
//                                       type="checkbox"
//                                       id={`color-${color.color_id}`}
//                                       checked={(ProductUser.available_color || []).includes(String(color.color_id))}
//                                       onChange={() => handleColorCheckbox(color.color_id)}
//                                     />
//                                     <label className="form-check-label d-flex align-items-center" htmlFor={`color-${color.color_id}`}>
//                                       <span
//                                         className="d-inline-block me-2 ms-2"
//                                         style={{
//                                           width: "20px",
//                                           height: "20px",
//                                           backgroundColor: color.code,
//                                           border: "1px solid #ddd",
//                                           borderRadius: "3px"
//                                         }}
//                                       ></span>
//                                       {color.color_name}
//                                     </label>
//                                   </div>
//                                 ))
//                               ) : (
//                                 <p className="text-muted mb-0">No colors available</p>
//                               )}
//                             </div>
//                           </div>
//                         )}
//                       </div>
//                     </div>

//                     {/* ELECTRONICS BLOCK */}
//                     {String(ProductUser.main_category) === "1" && (
//                       <>
//                         <hr className="mt-4 mb-2" />
//                         <h5 className="text-primary">Electronics Specifications</h5>

//                         <div className="col-lg-6">
//                           <label className="form-label">Company Name</label>
//                           <input
//                             type="text"
//                             name="company_name"
//                             value={ProductUser.company_name}
//                             onChange={handleInput}
//                             className="form-control"
//                             placeholder="e.g. Apple"
//                           />
//                         </div>

//                         <div className="col-lg-6">
//                           <label className="form-label">Model Name</label>
//                           <input
//                             type="text"
//                             name="model_name"
//                             value={ProductUser.model_name}
//                             onChange={handleInput}
//                             className="form-control"
//                             placeholder="e.g. iPhone 16"
//                           />
//                         </div>

//                         <div className="col-12">
//                           <label className="form-label">Specifications</label>
//                           <div className="row g-3">
//                             <div className="col-lg-4">
//                               <input
//                                 type="text"
//                                 name="ram"
//                                 value={ProductUser.ram}
//                                 onChange={handleInput}
//                                 className="form-control"
//                                 placeholder="RAM (e.g. 8GB)"
//                               />
//                             </div>
//                             <div className="col-lg-4">
//                               <input
//                                 type="text"
//                                 name="rom"
//                                 value={ProductUser.rom}
//                                 onChange={handleInput}
//                                 className="form-control"
//                                 placeholder="ROM (e.g. 128GB)"
//                               />
//                             </div>
//                             <div className="col-lg-4">
//                               <input
//                                 type="text"
//                                 name="processor"
//                                 value={ProductUser.processor}
//                                 onChange={handleInput}
//                                 className="form-control"
//                                 placeholder="Processor"
//                               />
//                             </div>
//                             <div className="col-lg-4">
//                               <input
//                                 type="text"
//                                 name="camera"
//                                 value={ProductUser.camera}
//                                 onChange={handleInput}
//                                 className="form-control"
//                                 placeholder="Camera"
//                               />
//                             </div>
//                             <div className="col-lg-4">
//                               <input
//                                 type="text"
//                                 name="battery"
//                                 value={ProductUser.battery}
//                                 onChange={handleInput}
//                                 className="form-control"
//                                 placeholder="Battery (mAh)"
//                               />
//                             </div>
//                             <div className="col-lg-4">
//                               <input
//                                 type="text"
//                                 name="operating_system"
//                                 value={ProductUser.operating_system}
//                                 onChange={handleInput}
//                                 className="form-control"
//                                 placeholder="Operating System"
//                               />
//                             </div>
//                           </div>
//                         </div>
//                       </>
//                     )}

//                     {/* FASHION BLOCK */}
//                     {String(ProductUser.main_category) === "2" && (
//                       <>
//                         <hr className="mt-4 mb-2" />
//                         <h5 className="text-primary">Fashion Specifications</h5>

//                         <div className="col-lg-6">
//                           <label className="form-label">Brand Name</label>
//                           <input
//                             type="text"
//                             name="fashion_brand_name"
//                             value={ProductUser.fashion_brand_name}
//                             onChange={handleInput}
//                             className="form-control"
//                             placeholder="Enter brand name (e.g. Levi's)"
//                           />
//                         </div>

//                         <div className="col-lg-6">
//                           <label className="form-label">Material</label>
//                           <input
//                             type="text"
//                             name="material"
//                             value={ProductUser.material}
//                             onChange={handleInput}
//                             className="form-control"
//                             placeholder="e.g. Cotton"
//                           />
//                         </div>

//                         <div className="col-lg-6">
//                           <label className="form-label">Fit Type</label>
//                           <input
//                             type="text"
//                             name="fit_type"
//                             value={ProductUser.fit_type}
//                             onChange={handleInput}
//                             className="form-control"
//                             placeholder="e.g. Regular Fit"
//                           />
//                         </div>

//                         <div className="col-lg-6">
//                           <label className="form-label">Occasion</label>
//                           <input
//                             type="text"
//                             name="occasion"
//                             value={ProductUser.occasion}
//                             onChange={handleInput}
//                             className="form-control"
//                             placeholder="e.g. Casual"
//                           />
//                         </div>

//                         <div className="col-lg-6">
//                           <label className="form-label">Care Instructions</label>
//                           <input
//                             type="text"
//                             name="care_instructions"
//                             value={ProductUser.care_instructions}
//                             onChange={handleInput}
//                             className="form-control"
//                             placeholder="e.g. Machine wash cold"
//                           />
//                         </div>
//                       </>
//                     )}

//                     {/* Common remaining fields */}
//                     <div className="col-lg-6">
//                       <label className="form-label">Stock</label>
//                       <input
//                         type="text"
//                         name="prod_stock"
//                         value={ProductUser.prod_stock}
//                         onChange={handleInput}
//                         className="form-control"
//                         placeholder="Enter stock quantity"
//                       />
//                     </div>

//                     <div className="col-lg-6">
//                       <label className="form-label">Rating</label>
//                       <input
//                         type="text"
//                         name="rating"
//                         value={ProductUser.rating}
//                         onChange={handleInput}
//                         className="form-control"
//                         placeholder="Enter rating (e.g. 4.5)"
//                       />
//                     </div>

//                     <div className="col-lg-6">
//                       <label className="form-label">Apply Discount</label>
//                       <div className="position-relative">
//                         <div
//                           className="form-control d-flex justify-content-between align-items-center"
//                           style={{ cursor: "pointer" }}
//                           onClick={() => setIsDiscountDropdownOpen(!isDiscountDropdownOpen)}
//                         >
//                           <span>
//                             {ProductUser.discount_id
//                               ? DiscountUser.find(d => String(d.disc_id) === String(ProductUser.discount_id))?.disc_name
//                               : "Select discount"}
//                           </span>
//                           <span>{isDiscountDropdownOpen ? "▲" : "▼"}</span>
//                         </div>

//                         {isDiscountDropdownOpen && (
//                           <div
//                             className="border rounded bg-white position-absolute w-100 mt-1"
//                             style={{
//                               maxHeight: "250px",
//                               overflowY: "auto",
//                               zIndex: 1000,
//                               boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
//                             }}
//                           >
//                             <div className="p-2">
//                               <div
//                                 className="p-2 hover-bg-light"
//                                 style={{ cursor: "pointer" }}
//                                 onClick={() => {
//                                   setProductUser(prev => ({
//                                     ...prev,
//                                     discount_id: "",
//                                     discount: ""
//                                   }));
//                                   setIsDiscountDropdownOpen(false);
//                                 }}
//                               >
//                                 <small className="text-muted">No Discount</small>
//                               </div>

//                               {DiscountUser.length > 0 ? (
//                                 DiscountUser.filter(disc => disc.status === "1").map((item) => (
//                                   <div
//                                     key={item.disc_id}
//                                     className="p-2 border-bottom hover-bg-light"
//                                     style={{ cursor: "pointer" }}
//                                     onClick={() => {
//                                       setProductUser(prev => ({
//                                         ...prev,
//                                         discount_id: item.disc_id,
//                                         discount: item.disc_amount
//                                       }));
//                                       setIsDiscountDropdownOpen(false);
//                                     }}
//                                   >
//                                     <div className="d-flex justify-content-between align-items-start">
//                                       <div>
//                                         <div className="fw-semibold">{item.disc_name}</div>
//                                         <small className="text-muted">
//                                           {item.disc_start_date} to {item.disc_end_date}
//                                         </small>
//                                       </div>
//                                       <span className="badge bg-success">₹{item.disc_amount} OFF</span>
//                                     </div>
//                                   </div>
//                                 ))
//                               ) : (
//                                 <p className="text-muted mb-0 p-2">No active discounts available</p>
//                               )}
//                             </div>
//                           </div>
//                         )}
//                       </div>
//                     </div>

//                     <div className="col-lg-6">
//                       <label className="form-label">Description</label>
//                       <input
//                         type="text"
//                         name="description"
//                         value={ProductUser.description}
//                         onChange={handleInput}
//                         className="form-control"
//                         placeholder="Short product description"
//                       />
//                     </div>

//                     <div className="col-lg-6">
//                       <label className="form-label">Product Details</label>
//                       <input
//                         type="text"
//                         name="product_details"
//                         value={ProductUser.product_details}
//                         onChange={handleInput}
//                         className="form-control"
//                         placeholder="Additional details"
//                       />
//                     </div>

//                     <div className="col-lg-6">
//                       <label className="form-label">Weight</label>
//                       <input
//                         type="text"
//                         name="weight"
//                         value={ProductUser.weight}
//                         onChange={handleInput}
//                         className="form-control"
//                         placeholder="Enter weight"
//                       />
//                     </div>

//                     <div className="col-lg-6">
//                       <label className="form-label">Dimension</label>
//                       <input
//                         type="text"
//                         name="dimension"
//                         value={ProductUser.dimension}
//                         onChange={handleInput}
//                         className="form-control"
//                         placeholder="Enter Dimension"
//                       />
//                     </div>

//                     <div className="col-lg-6">
//                       <label className="form-label">Assign Vendor</label>
//                       <select
//                         className="form-control"
//                         name="prod_vendor_assign"
//                         value={ProductUser.prod_vendor_assign}
//                         onChange={handleInput}
//                       >
//                         <option value="">Select Vendor</option>
//                         <option value="H&M">H&M</option>
//                         <option value="Nike">Nike</option>
//                         <option value="Zara">Zara</option>
//                       </select>
//                     </div>

//                     <div className="col-lg-6">
//                       <label className="form-label">Product Status</label>
//                       <select
//                         className="form-control"
//                         name="product_status"
//                         value={ProductUser.product_status}
//                         onChange={handleInput}
//                       >
//                         <option value="">-- None --</option>
//                         <option value="Top Deals">Top Deals</option>
//                         <option value="Fashion Top Deals">Fashion Top Deals</option>
//                         <option value="Shop Your Favorites">Shop Your Favorites</option>
//                         <option value="Special Offers">Special Offers</option>
//                         <option value="Grand Global Brand">Grand Global Brand</option>
//                         <option value="Shop By Category">Shop By Category</option>
//                         <option value="Top Pick of the sale">Top Pick of the sale</option>
//                         <option value="Crazy Deals">Crazy Deals</option>
//                         <option value="Products for you">Products for you</option>
//                         <option value="Groceries">Groceries</option>
//                       </select>
//                     </div>

//                     <div className="col-lg-6">
//                       <label className="form-label">Paid Promotion</label>
//                       <select
//                         className="form-control"
//                         name="paid_promo"
//                         value={ProductUser.paid_promo}
//                         onChange={handleInput}
//                       >
//                         <option value="">-- Select Paid Promotion --</option>
//                         <option value="yes">Yes</option>
//                         <option value="no">No</option>
//                       </select>
//                     </div>

//                     <div className="col-lg-6">
//                       <label className="form-label">Paid Promotion Approval</label>
//                       <select
//                         className="form-control"
//                         name="paid_approval"
//                         value={ProductUser.paid_approval}
//                         onChange={handleInput}
//                       >
//                         <option value="">-- Select Paid Promotion Approval--</option>
//                         <option value="yes">Approve</option>
//                         <option value="no">Reject</option>
//                       </select>
//                     </div>

//                     <div className="col-lg-6">
//                       <label className="form-label">Status</label>
//                       <select
//                         className="form-control"
//                         name="status"
//                         value={ProductUser.status}
//                         onChange={handleInput}
//                       >
//                         <option value="">-- Select Status --</option>
//                         <option value="Instock">In stock</option>
//                         <option value="Outofstock">Out of stock</option>
//                         <option value="fewleft">Few left</option>
//                       </select>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Action Buttons */}
//               <div className="p-3 bg-light mb-3 rounded">
//                 <div className="row justify-content-end g-2">
//                   <div className="col-lg-2">
//                     <button type="submit" className="btn btn-outline-secondary w-100">
//                       Create Product
//                     </button>
//                   </div>
//                   <div className="col-lg-2">
//                     <Link to="/product-list" className="btn btn-primary w-100">
//                       Cancel
//                     </Link>
//                   </div>
//                 </div>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>

//       {/* Footer */}
//       <footer className="footer">
//         <div className="container-fluid text-center py-3">
//           © Venton. Crafted by{" "}
//           <span className="text-danger">❤️</span> <strong>Techzaa</strong>
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default ProductCreate;


import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";

/* ─────────────────────────────────────────────────────────────────────────────
   API base
───────────────────────────────────────────────────────────────────────────── */
const API = "https://cyberathon.com/multivendor/index.php/Api/Master_controller";

/* ─────────────────────────────────────────────────────────────────────────────
   BulkImportModal
───────────────────────────────────────────────────────────────────────────── */
const BulkImportModal = ({ show, onClose, sellerId }) => {
  const fileRef   = useRef(null);
  const folderRef = useRef(null);
  const [rows,         setRows]         = useState([]);
  const [fileName,     setFileName]     = useState("");
  const [importing,    setImporting]    = useState(false);
  const [results,      setResults]      = useState([]);
  const [downloading,  setDownloading]  = useState(false);
  const [imageFileMap,   setImageFileMap]   = useState({});
  const [folderName,     setFolderName]     = useState("");
  const [imageWarnings,  setImageWarnings]  = useState([]); // per-row unmatched filenames

  const [validSizes,      setValidSizes]      = useState([]);
  const [validColors,     setValidColors]     = useState([]);
  const [validBrands,     setValidBrands]     = useState([]);
  const [validDiscounts,  setValidDiscounts]  = useState([]);
  const [validCategories, setValidCategories] = useState([]);

  const REQUIRED     = ["product_name", "current_price", "prod_stock", "main_category", "status"];
  const VALID_STATUS = ["Instock", "Outofstock", "fewleft"];
  const VALID_YESNO  = ["yes", "no"];
  const STATUS_MAP   = { instock: "In Stock", outofstock: "Out of Stock", fewleft: "Few Left" };

  /* ── Download template with live data ─────────────────────────────────── */
  const downloadTemplate = async () => {
    setDownloading(true);
    toast.info("Fetching latest data for template…");
    try {
      const [catRes, sizeRes, colorRes, discRes, brandRes] = await Promise.allSettled([
        axios.get(`${API}/list_main_category`),
        axios.get(`${API}/list_mst_prod_size`),
        axios.get(`${API}/list_mst_prod_color`),
        axios.get(`${API}/discount_list`),
        axios.get(`${API}/Brand_list`),
      ]);

      const categories = catRes.status   === "fulfilled" ? (catRes.value.data?.row    || []) : [];
      const sizes      = sizeRes.status  === "fulfilled" ? (sizeRes.value.data?.row   || []) : [];
      const colors     = colorRes.status === "fulfilled" ? (colorRes.value.data?.colors || []) : [];
      const discounts  = discRes.status  === "fulfilled" ? (discRes.value.data?.data   || []).filter(d => d.status === "1") : [];
      const brands     = brandRes.status === "fulfilled" ? (brandRes.value.data?.data  || []).filter(b => b.status === "active") : [];

      setValidSizes(sizes.map(s => ({ id: String(s.size_id), label: s.size_label || s.size })));
      setValidColors(colors.map(c => ({ id: String(c.color_id), name: c.color_name })));
      setValidBrands(brands.map(b => ({ id: String(b.brand_id), name: b.brand_name })));
      setValidDiscounts(discounts.map(d => ({ id: String(d.disc_id), name: d.disc_name })));
      setValidCategories(categories.map(c => ({ id: String(c.category_id), name: c.category_name })));

      const wb = XLSX.utils.book_new();

      // ── Sheet 1: Products ─────────────────────────────────────────────
      const KEY_HEADERS = [
        "product_name","current_price","old_price","prod_stock","rating",
        "description","product_details","main_category","sub_category","brand_id",
        "size_id","available_color","discount_id","status","product_status",
        "paid_promo","paid_approval","weight","dimension",
        "image_filenames",   // ← Column T: sellers fill image filenames here
        "company_name","model_name","ram","rom","processor","camera","battery","operating_system",
        "fashion_brand_name","material","fit_type","occasion","care_instructions",
      ];

      // Row 1: human-readable hint row
      const HINT_ROW = [
        "Product Name *","Current Price *","Old Price","Stock *","Rating 0-5",
        "Description","Product Details","Category ID (see ref sheet)","Subcategory ID","Brand ID (see ref)",
        "Size IDs comma-sep","Color IDs comma-sep","Discount ID (see ref)","Status (see ref)","Product Status (see ref)",
        "yes or no","yes or no","Weight","Dimension",
        // ↓ FIX: clear, prominent label for image column
        "📷 IMAGE FILENAMES — comma-separated (e.g. img1.png,img2.webp) — must match your uploaded folder exactly",
        "Electronics only","Electronics only","Electronics only","Electronics only",
        "Electronics only","Electronics only","Electronics only","Electronics only",
        "Fashion only","Fashion only","Fashion only","Fashion only","Fashion only",
      ];

      // FIX: sample rows now include example image filenames so sellers can see exactly how to fill this column
      const sample1 = [
        "Samsung Galaxy S24", 59999, 74999, 100, 4.5,
        "Flagship smartphone", "6.2-inch 120Hz display",
        categories[0]?.category_id || 1, "", brands[0]?.brand_id || "",
        sizes[0]?.size_id || "", colors[0]?.color_id || "", "",
        "Instock", "Top Deals", "no", "no", "185g", "147x71x7.6mm",
        "samsung_s24_front.png,samsung_s24_back.webp,samsung_s24_side.png",  // ← image_filenames example
        "Samsung","Galaxy S24","8GB","256GB","Snapdragon 8 Gen 3","50MP","4000mAh","Android 14",
        "","","","","",
      ];

      const sample2 = [
        "Men's Slim Fit Jeans", 1299, 2499, 50, 4.2,
        "Classic slim fit denim", "Stretch fabric",
        categories[1]?.category_id || 2, "", brands[1]?.brand_id || "",
        sizes.slice(0,2).map(s => s.size_id).join(",") || "",
        colors.slice(0,2).map(c => c.color_id).join(",") || "", "",
        "Instock", "Fashion Top Deals", "no", "no", "600g", "30x40cm",
        "jeans_front.webp,jeans_back.png",  // ← image_filenames example
        "","","","","","","","",
        "Levi's","Denim","Slim Fit","Casual","Machine wash cold",
      ];

      // aoa: row1=hints, row2=exact keys (parser header), row3-4=samples
      const ws1 = XLSX.utils.aoa_to_sheet([HINT_ROW, KEY_HEADERS, sample1, sample2]);

      // Make all columns 22 chars wide, but make image_filenames column (index 19 = col T) wider
      const colWidths = KEY_HEADERS.map((_, i) => ({ wch: i === 19 ? 52 : 22 }));
      ws1["!cols"] = colWidths;
      ws1["!freeze"] = { xSplit: 0, ySplit: 2 };
      XLSX.utils.book_append_sheet(wb, ws1, "Products");

      // ── Sheet 2: Reference ────────────────────────────────────────────
      const ref = [];
      ref.push(["⚠ DO NOT EDIT THIS SHEET — For reference only"]);
      ref.push([]);

      ref.push(["HOW TO ADD IMAGES"]);
      ref.push(["Step", "What to do"]);
      ref.push(["1", "In the Products sheet, column T (image_filenames), type your image filenames comma-separated"]);
      ref.push(["2", "Example: product_front.png,product_back.webp,product_side.png"]);
      ref.push(["3", "Filenames are case-insensitive but must match exactly what is in your images folder"]);
      ref.push(["4", "In the Bulk Import modal, use Step 3 to select the folder containing those images"]);
      ref.push(["5", "Supported formats: .png, .webp, .jpg, .jpeg"]);
      ref.push([]);

      ref.push(["STATUS — column: status"]);
      ref.push(["Value", "Displayed As"]);
      VALID_STATUS.forEach(s => ref.push([s, STATUS_MAP[s.toLowerCase()] || s]));
      ref.push([]);

      ref.push(["PAID PROMO / PAID APPROVAL — column: paid_promo, paid_approval"]);
      ref.push(["Value"]);
      VALID_YESNO.forEach(v => ref.push([v]));
      ref.push([]);

      ref.push(["MAIN CATEGORY — column: main_category (enter the ID number)"]);
      ref.push(["ID", "Category Name"]);
      categories.forEach(c => ref.push([c.category_id, c.category_name]));
      ref.push([]);

      ref.push(["BRANDS — column: brand_id (enter ONE ID number)"]);
      ref.push(["ID", "Brand Name", "Manufacturer"]);
      brands.forEach(b => ref.push([b.brand_id, b.brand_name, b.manuf_name || ""]));
      ref.push([]);

      ref.push(["SIZES — column: size_id (can enter MULTIPLE IDs comma-separated e.g. 1,2,3)"]);
      ref.push(["ID", "Size Label"]);
      sizes.forEach(s => ref.push([s.size_id, s.size_label || s.size]));
      ref.push([]);

      ref.push(["COLORS — column: available_color (can enter MULTIPLE IDs comma-separated e.g. 1,2,3)"]);
      ref.push(["ID", "Color Name", "Hex Code"]);
      colors.forEach(c => ref.push([c.color_id, c.color_name, c.code || ""]));
      ref.push([]);

      ref.push(["DISCOUNTS — column: discount_id (enter ONE ID or leave blank)"]);
      ref.push(["ID", "Discount Name", "Amount Off", "Start Date", "End Date"]);
      discounts.forEach(d => ref.push([d.disc_id, d.disc_name, `${d.disc_amount} OFF`, d.disc_start_date, d.disc_end_date]));
      ref.push([]);

      ref.push(["PRODUCT STATUS — column: product_status"]);
      ref.push(["Value"]);
      ["Top Deals","Fashion Top Deals","Shop Your Favorites","Special Offers",
       "Grand Global Brand","Shop By Category","Top Pick of the sale",
       "Crazy Deals","Products for you","Groceries"].forEach(v => ref.push([v]));

      const ws2 = XLSX.utils.aoa_to_sheet(ref);
      ws2["!cols"] = [{ wch: 32 }, { wch: 60 }, { wch: 20 }, { wch: 20 }, { wch: 20 }];
      XLSX.utils.book_append_sheet(wb, ws2, "Reference (Read Only)");

      XLSX.writeFile(wb, "product_import_template.xlsx");
      toast.success("Template downloaded with your live data!");
    } catch (err) {
      console.error(err);
      toast.error("Failed to generate template. Check your connection.");
    } finally {
      setDownloading(false);
    }
  };

  /* ── Handle image folder selection ───────────────────────────────────── */
  const handleFolderSelect = (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    const map = {};
    files.forEach(file => { map[file.name.toLowerCase()] = file; });
    setImageFileMap(map);
    const firstPath = files[0].webkitRelativePath || files[0].name;
    const folder    = firstPath.includes("/") ? firstPath.split("/")[0] : "Selected folder";
    setFolderName(`${folder} (${files.length} image${files.length !== 1 ? "s" : ""})`);
    toast.success(`${files.length} image file(s) loaded from folder.`);
  };

  /* ── Parse uploaded Excel ──────────────────────────────────────────────── */
  const handleFile = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setFileName(file.name);
    setRows([]);
    setResults([]);
    const reader = new FileReader();
    reader.onload = (evt) => {
      try {
        const wb  = XLSX.read(evt.target.result, { type: "binary" });
        const ws  = wb.Sheets[wb.SheetNames[0]];

        const raw = XLSX.utils.sheet_to_json(ws, { header: 1, defval: "" });
        if (raw.length < 2) { toast.error("No data found in the Excel sheet."); return; }

        // Auto-detect header row: scan first 5 rows for one containing "product_name"
        let headerRowIndex = 0;
        for (let i = 0; i < Math.min(raw.length, 5); i++) {
          const cells = raw[i].map(c => String(c).toLowerCase().trim());
          if (cells.some(c => c === "product_name" || c === "product name")) {
            headerRowIndex = i;
            break;
          }
        }

        const headers = raw[headerRowIndex].map(h =>
          String(h).trim()
            .replace(/\s*\*.*/,  "")
            .replace(/\s*\(.*?\)/g, "")
            .replace(/\s*\[.*?\]/g, "")
            .toLowerCase()
            .replace(/\s+/g, "_")
            .replace(/^stock$/, "prod_stock")
        );

        const dataRows = raw
          .slice(headerRowIndex + 1)
          .filter(row => row.some(cell => String(cell).trim() !== ""));

        if (!dataRows.length) { toast.error("No product rows found. Delete the sample rows and add your data."); return; }

        const parsed = dataRows.map(row => {
          const obj = {};
          headers.forEach((key, i) => { obj[key] = row[i] ?? ""; });
          return obj;
        });

        setRows(parsed);
        toast.info(`${parsed.length} row(s) loaded. Review below, then click Import.`);
      } catch (err) {
        console.error(err);
        toast.error("Failed to read file. Please upload a valid .xlsx file.");
      }
    };
    reader.readAsBinaryString(file);
  };

  /* ── Validate a single row ─────────────────────────────────────────────── */
  const validate = (row) => {
    const errors = [];

    if (!String(row.product_name   || "").trim()) errors.push('"product_name" is required');
    if (!String(row.current_price  || "").trim()) errors.push('"current_price" is required');
    if (!String(row.prod_stock     || "").trim()) errors.push('"stock" is required');
    if (!String(row.main_category  || "").trim()) errors.push('"main_category" is required');
    if (!String(row.status         || "").trim()) errors.push('"status" is required');
    if (errors.length) return errors;

    if (isNaN(parseFloat(row.current_price))) errors.push("current_price must be a number");

    const statusVal = String(row.status || "").trim();
    if (!VALID_STATUS.map(s => s.toLowerCase()).includes(statusVal.toLowerCase()))
      errors.push(`status "${statusVal}" is invalid — must be: ${VALID_STATUS.join(" | ")}`);

    if (row.paid_promo && String(row.paid_promo).trim() &&
        !VALID_YESNO.includes(String(row.paid_promo).trim().toLowerCase()))
      errors.push(`paid_promo must be "yes" or "no", got "${row.paid_promo}"`);

    if (row.paid_approval && String(row.paid_approval).trim() &&
        !VALID_YESNO.includes(String(row.paid_approval).trim().toLowerCase()))
      errors.push(`paid_approval must be "yes" or "no", got "${row.paid_approval}"`);

    if (validCategories.length && row.main_category) {
      const validIds = validCategories.map(c => String(c.id));
      if (!validIds.includes(String(row.main_category).trim()))
        errors.push(`main_category "${row.main_category}" is invalid. Valid IDs: ${validIds.join(", ")}`);
    }

    if (validBrands.length && row.brand_id && String(row.brand_id).trim()) {
      const validIds = validBrands.map(b => String(b.id));
      if (!validIds.includes(String(row.brand_id).trim()))
        errors.push(`brand_id "${row.brand_id}" not found. See Reference sheet for valid Brand IDs.`);
    }

    if (validSizes.length && row.size_id && String(row.size_id).trim()) {
      const validIds  = validSizes.map(s => String(s.id));
      const inputIds  = String(row.size_id).split(",").map(s => s.trim()).filter(Boolean);
      const bad       = inputIds.filter(id => !validIds.includes(id));
      if (bad.length)
        errors.push(`Invalid size ID(s): ${bad.join(", ")}. Valid IDs: ${validIds.join(", ")}`);
    }

    if (validColors.length && row.available_color && String(row.available_color).trim()) {
      const validIds = validColors.map(c => String(c.id));
      const inputIds = String(row.available_color).split(",").map(s => s.trim()).filter(Boolean);
      const bad      = inputIds.filter(id => !validIds.includes(id));
      if (bad.length)
        errors.push(`Invalid color ID(s): ${bad.join(", ")}. Valid IDs: ${validIds.join(", ")}`);
    }

    if (validDiscounts.length && row.discount_id && String(row.discount_id).trim()) {
      const validIds = validDiscounts.map(d => String(d.id));
      if (!validIds.includes(String(row.discount_id).trim()))
        errors.push(`discount_id "${row.discount_id}" not found or inactive. Valid IDs: ${validIds.join(", ")}`);
    }

    return errors.length ? errors : null;
  };

  /* ── Submit rows to API ────────────────────────────────────────────────── */
  const handleImport = async () => {
    if (!rows.length) { toast.warning("No data to import."); return; }

    // Pre-flight image check
    const rowsNeedingImages = rows.filter(r =>
      String(r.image_filenames || "").split(",").map(f => f.trim()).filter(Boolean).length > 0
    );
    if (rowsNeedingImages.length > 0 && Object.keys(imageFileMap).length === 0) {
      toast.warning(
        `⚠️ ${rowsNeedingImages.length} row(s) have image filenames but no folder is selected. ` +
        `Importing anyway — products will be created WITHOUT images. Select a folder and re-import to add images.`,
        { autoClose: 6000 }
      );
    }

    setImporting(true);
    const outcomes = [];
    let totalImagesSkipped = 0;

    for (let i = 0; i < rows.length; i++) {
      const row  = rows[i];
      const errs = validate(row);
      if (errs) { outcomes.push({ row: i + 1, status: "error", msg: errs.join(" | ") }); continue; }

      try {
        const fd = new FormData();
        fd.append("seller_id",        sellerId || "");
        fd.append("product_name",     String(row.product_name    || "").trim());
        fd.append("current_price",    String(row.current_price   || "").trim());
        fd.append("old_price",        String(row.old_price       || "").trim());
        fd.append("stock",            String(row.prod_stock      || "").trim());
        fd.append("rating",           String(row.rating          || "").trim());
        fd.append("description",      String(row.description     || "").trim());
        fd.append("product_details",  String(row.product_details || "").trim());
        fd.append("weight",           String(row.weight          || "").trim());
        fd.append("dimension",        String(row.dimension       || "").trim());
        fd.append("category_id",      String(row.main_category   || "").trim());
        fd.append("subcategory_id",   String(row.sub_category    || "").trim());
        fd.append("brand_id",         String(row.brand_id        || "").trim());
        fd.append("product_status",   String(row.product_status  || "").trim());
        fd.append("paid_promo",       String(row.paid_promo      || "").trim());
        fd.append("paid_approval",    String(row.paid_approval   || "").trim());
        fd.append("discount_id",      String(row.discount_id     || "").trim());
        fd.append("size_id",          String(row.size_id         || "").trim());
        fd.append("available_color",  String(row.available_color || "").trim());

        const rawStatus = String(row.status || "").toLowerCase().replace(/\s/g, "");
        fd.append("status", STATUS_MAP[rawStatus] || "Out of Stock");

        fd.append("company_name",      String(row.company_name     || "").trim());
        fd.append("model_name",        String(row.model_name       || "").trim());
        fd.append("ram",               String(row.ram              || "").trim());
        fd.append("rom",               String(row.rom              || "").trim());
        fd.append("processor",         String(row.processor        || "").trim());
        fd.append("camera",            String(row.camera           || "").trim());
        fd.append("battery",           String(row.battery          || "").trim());
        fd.append("operating_system",  String(row.operating_system || "").trim());

        fd.append("fashion_brand_name",  String(row.fashion_brand_name || "").trim());
        fd.append("material",            String(row.material           || "").trim());
        fd.append("fit_type",            String(row.fit_type           || "").trim());
        fd.append("occasion",            String(row.occasion           || "").trim());
        fd.append("care_instructions",   String(row.care_instructions  || "").trim());

        // Match image filenames from Excel to files in the uploaded folder
        const filenames = String(row.image_filenames || "")
          .split(",")
          .map(f => f.trim().toLowerCase())
          .filter(Boolean);

        let matchedCount   = 0;
        let unmatchedNames = [];
        filenames.forEach(name => {
          const matched = imageFileMap[name];
          if (matched) {
            fd.append("multi_image[]", matched);
            matchedCount++;
          } else if (name) {
            unmatchedNames.push(name);
            totalImagesSkipped++;
          }
        });

        const res = await axios.post(`${API}/add_create_product`, fd, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        const d  = res.data;
        const ok = d?.status === true || d?.success === "1" || d?.status === "true";
        const imageNote = unmatchedNames.length
          ? ` (⚠ ${unmatchedNames.length} image(s) skipped — not found in folder: ${unmatchedNames.join(", ")})`
          : matchedCount > 0
            ? ` (✓ ${matchedCount} image(s) uploaded)`
            : "";
        outcomes.push({
          row: i + 1,
          status: ok ? "success" : "error",
          msg: (d?.message || "") + imageNote,
        });
      } catch (ex) {
        outcomes.push({ row: i + 1, status: "error", msg: ex.message || "Network error" });
      }
    }

    setResults(outcomes);
    setImporting(false);
    const ok  = outcomes.filter(o => o.status === "success").length;
    const bad = outcomes.filter(o => o.status === "error").length;
    if (ok)  toast.success(`${ok} product(s) imported successfully!`);
    if (bad) toast.error(`${bad} row(s) failed — see results table.`);
    if (totalImagesSkipped > 0)
      toast.warning(`⚠️ ${totalImagesSkipped} image file(s) were skipped because their filenames didn't match any file in your selected folder. Check the results table for details.`, { autoClose: 8000 });
  };

  const reset = () => {
    setRows([]); setFileName(""); setResults([]);
    setImageFileMap({}); setFolderName(""); setImageWarnings([]);
    if (fileRef.current)   fileRef.current.value   = "";
    if (folderRef.current) folderRef.current.value = "";
  };

  const previewData = rows.map((row, i) => {
    const filenames = String(row.image_filenames || "")
      .split(",").map(f => f.trim().toLowerCase()).filter(Boolean);
    const matched   = filenames.filter(f => imageFileMap[f]);
    const unmatched = filenames.filter(f => !imageFileMap[f]);
    return {
      idx: i,
      name:      String(row.product_name    || "–"),
      price:     row.current_price          || "–",
      stock:     row.prod_stock             || "–",
      category:  row.main_category          || "–",
      status:    row.status                 || "–",
      brand:     row.brand_id               || "–",
      sizes:     row.size_id                || "–",
      colors:    row.available_color        || "–",
      filenames,
      matched,
      unmatched,
      errors:    validate(row),
    };
  });

  const hasErrors            = previewData.some(r => r.errors);
  const needsLookup          = !validBrands.length && rows.length > 0;
  const rowsWithImages       = previewData.filter(r => r.filenames.length > 0);
  const noFolderButHasImages = rowsWithImages.length > 0 && Object.keys(imageFileMap).length === 0;
  const hasUnmatched         = previewData.some(r => r.unmatched.length > 0);

  if (!show) return null;

  return (
    <div
      className="modal d-block"
      style={{ background: "rgba(0,0,0,0.6)", zIndex: 9999 }}
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="modal-dialog modal-xl modal-dialog-scrollable">
        <div className="modal-content">

          <div className="modal-header" style={{ background: "#ff3e6c" }}>
            <h5 className="modal-title text-white fw-semibold">📥 Bulk Product Import via Excel</h5>
            <button type="button" className="btn-close btn-close-white" onClick={onClose} />
          </div>

          <div className="modal-body p-4">

            {/* Step 1 – Download */}
            <div className="card border-0 mb-4" style={{ background: "#fff5f8" }}>
              <div className="card-body">
                <div className="d-flex align-items-start gap-3 flex-wrap">
                  <div className="flex-grow-1">
                    <h6 className="fw-semibold mb-1">
                      Step 1 — Download Live Template
                      <span className="badge bg-primary ms-2" style={{ fontSize: 10 }}>Fetches your real data</span>
                    </h6>
                    <p className="mb-2 text-muted small">
                      The template downloads with a <strong>Reference sheet</strong> containing
                      all your actual Brand IDs, Size IDs, Color IDs, Discount IDs and Category IDs
                      from the database — so sellers always use valid values.
                    </p>
                    <div className="row g-2 small text-muted">
                      <div className="col-md-6">
                        <div className="p-2 bg-white rounded border">
                          <strong>✓ Validated on upload:</strong>
                          <ul className="mb-0 ps-3 mt-1">
                            <li>Brand ID — must match a live brand</li>
                            <li>Size IDs — each must match a live size</li>
                            <li>Color IDs — each must match a live color</li>
                            <li>Discount ID — must be active</li>
                            <li>Category ID — must exist</li>
                          </ul>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="p-2 bg-white rounded border">
                          <strong>✓ Fixed values:</strong>
                          <ul className="mb-0 ps-3 mt-1">
                            <li>Status: <code>Instock</code> · <code>Outofstock</code> · <code>fewleft</code></li>
                            <li>Paid Promo / Approval: <code>yes</code> · <code>no</code></li>
                            <li>Size &amp; Color IDs: comma-sep e.g. <code>1,2,3</code></li>
                            <li>Brand / Discount: single ID</li>
                            <li>Images: comma-sep filenames in column T e.g. <code>img1.png,img2.webp</code></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button
                    className="btn btn-primary flex-shrink-0 d-flex align-items-center gap-2"
                    onClick={downloadTemplate}
                    disabled={downloading}
                  >
                    {downloading
                      ? <><span className="spinner-border spinner-border-sm" /> Generating…</>
                      : <>⬇ Download Live Template</>}
                  </button>
                </div>
              </div>
            </div>

            {/* Step 2 – Upload Excel */}
            <div className="mb-3">
              <h6 className="fw-semibold mb-2">Step 2 — Upload Your Filled Excel File</h6>
              <input ref={fileRef} type="file" accept=".xlsx,.xls" className="form-control" onChange={handleFile} />
              {fileName && (
                <div className="mt-1">
                  <small className="text-muted">
                    📄 <strong>{fileName}</strong> — {rows.length} row(s) detected
                  </small>
                  {needsLookup && (
                    <div className="alert alert-warning py-2 small mt-2 mb-0">
                      ⚠ <strong>Download the template first</strong> to enable Brand ID, Size ID, Color ID
                      and Discount ID validation. Without it, only basic field checks apply.
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Step 3 – Images folder */}
            <div className="mb-4">
              <h6 className="fw-semibold mb-2">
                Step 3 — Select Your Images Folder
                <span className="text-muted fw-normal"> (optional)</span>
              </h6>
              <div className="p-3 rounded border" style={{ background: "#f8f9fa" }}>
                <p className="text-muted small mb-2">
                  In your Excel, fill column <strong>T</strong> (<code>image_filenames</code>) with comma-separated
                  filenames e.g. <code>product_front.png,product_back.webp</code>. Then select the folder containing
                  those images here. Filenames are case-insensitive.
                </p>
                <input
                  ref={folderRef}
                  type="file"
                  className="form-control"
                  webkitdirectory="true"
                  directory="true"
                  multiple
                  onChange={handleFolderSelect}
                />
                {folderName && (
                  <small className="text-success d-block mt-1">
                    📁 <strong>{folderName}</strong> ready —
                    filenames must match exactly what you typed in column T of your Excel (case-insensitive)
                  </small>
                )}
                {!folderName && (
                  <small className="text-muted d-block mt-1">
                    No folder selected — products will be imported without images
                  </small>
                )}
                {/* Warn if Excel has image filenames but no folder was selected */}
                {noFolderButHasImages && (
                  <div className="alert alert-danger py-2 small mt-2 mb-0">
                    ⚠️ <strong>{rowsWithImages.length} row(s) in your Excel have filenames in the
                    <code> image_filenames</code> column but you haven't selected a folder yet.</strong>
                    {" "}Products will import <u>without images</u> unless you select your images folder above.
                  </div>
                )}
                {/* Warn if folder is selected but some filenames don't match */}
                {!noFolderButHasImages && hasUnmatched && folderName && (
                  <div className="alert alert-warning py-2 small mt-2 mb-0">
                    ⚠️ Some filenames in your Excel <strong>don't match any file in the selected folder</strong>.
                    Check the Images column in the preview table below — unmatched filenames are shown in red.
                    Those images will be skipped.
                  </div>
                )}
              </div>
            </div>

            {/* Preview table */}
            {rows.length > 0 && !results.length && (
              <div className="mb-4">
                <div className="d-flex align-items-center gap-2 mb-2">
                  <h6 className="fw-semibold mb-0">Preview — {rows.length} row{rows.length !== 1 ? "s" : ""}</h6>
                  {hasErrors
                    ? <span className="badge bg-danger">⚠ Errors found — fix in Excel &amp; re-upload</span>
                    : <span className="badge bg-success">✓ All rows valid</span>}
                </div>
                <div style={{ overflowX: "auto", maxHeight: 320 }}>
                  <table className="table table-sm table-bordered table-hover mb-0" style={{ fontSize: 12, whiteSpace: "nowrap" }}>
                    <thead className="table-dark sticky-top">
                      <tr>
                        <th>#</th>
                        <th>Product Name</th>
                        <th>Price</th>
                        <th>Stock</th>
                        <th>Category ID</th>
                        <th>Brand ID</th>
                        <th>Size IDs</th>
                        <th>Color IDs</th>
                        <th>Status</th>
                        <th>Images</th>
                        <th style={{ minWidth: 300 }}>Validation</th>
                      </tr>
                    </thead>
                    <tbody>
                      {previewData.slice(0, 100).map(r => (
                        <tr key={r.idx} className={r.errors ? "table-danger" : ""}>
                          <td>{r.idx + 1}</td>
                          <td>{r.name}</td>
                          <td>₹{r.price}</td>
                          <td>{r.stock}</td>
                          <td>{r.category}</td>
                          <td>{r.brand}</td>
                          <td>{r.sizes}</td>
                          <td>{r.colors}</td>
                          <td>{r.status}</td>
                          <td>
                            {r.filenames.length === 0 ? (
                              <span className="text-muted small">none</span>
                            ) : Object.keys(imageFileMap).length === 0 ? (
                              <span className="badge bg-secondary" title={r.filenames.join(", ")}>
                                {r.filenames.length} listed — no folder
                              </span>
                            ) : (
                              <div>
                                {r.matched.length > 0 && (
                                  <span className="badge bg-success me-1" title={r.matched.join(", ")}>
                                    ✓ {r.matched.length} matched
                                  </span>
                                )}
                                {r.unmatched.length > 0 && (
                                  <span className="badge bg-danger" title={r.unmatched.join(", ")}>
                                    ✗ {r.unmatched.length} not found
                                  </span>
                                )}
                              </div>
                            )}
                          </td>
                          <td>
                            {r.errors
                              ? r.errors.map((err, i) => (
                                <div key={i} className="badge bg-danger me-1 mb-1 text-wrap text-start"
                                  style={{ maxWidth: 450, whiteSpace: "normal", fontSize: 11 }}>
                                  ✗ {err}
                                </div>
                              ))
                              : <span className="badge bg-success">✓ OK</span>}
                          </td>
                        </tr>
                      ))}
                      {rows.length > 100 && (
                        <tr>
                          <td colSpan={11} className="text-center text-muted">
                            … {rows.length - 100} more rows not shown
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                {hasErrors && (
                  <div className="alert alert-warning mt-3 py-2 small mb-0">
                    <strong>How to fix:</strong> Open the downloaded template's <em>Reference (Read Only)</em>
                    sheet to see all valid IDs. Correct your data and re-upload.
                  </div>
                )}
              </div>
            )}

            {/* Results */}
            {results.length > 0 && (
              <div className="mb-2">
                <h6 className="fw-semibold mb-2">Import Results</h6>
                <div style={{ overflowX: "auto", maxHeight: 300 }}>
                  <table className="table table-sm table-bordered mb-0" style={{ fontSize: 12 }}>
                    <thead className="table-dark sticky-top">
                      <tr><th>Row</th><th>Product</th><th>Result</th><th>Message</th></tr>
                    </thead>
                    <tbody>
                      {results.map((r, i) => (
                        <tr key={i} className={r.status === "success" ? "table-success" : "table-danger"}>
                          <td>{r.row}</td>
                          <td>{String(rows[r.row - 1]?.product_name || "–")}</td>
                          <td>
                            {r.status === "success"
                              ? <span className="badge bg-success">✓ Imported</span>
                              : <span className="badge bg-danger">✗ Failed</span>}
                          </td>
                          <td className="text-muted" style={{ whiteSpace: "normal", maxWidth: 400 }}>{r.msg}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="d-flex gap-3 mt-3">
                  <span className="badge bg-success fs-6 py-2 px-3">
                    ✓ {results.filter(r => r.status === "success").length} Imported
                  </span>
                  <span className="badge bg-danger fs-6 py-2 px-3">
                    ✗ {results.filter(r => r.status === "error").length} Failed
                  </span>
                </div>
              </div>
            )}
          </div>

          <div className="modal-footer">
            {(rows.length > 0 || results.length > 0) && (
              <button className="btn btn-outline-secondary btn-sm" onClick={reset}>🔄 Clear & Reset</button>
            )}
            <button className="btn btn-light" onClick={onClose}>Close</button>
            <button
              className="btn btn-primary d-flex align-items-center gap-2"
              disabled={!rows.length || importing || results.length > 0 || hasErrors}
              onClick={handleImport}
            >
              {importing
                ? <><span className="spinner-border spinner-border-sm" /> Importing…</>
                : `📤 Import ${rows.length} Product${rows.length !== 1 ? "s" : ""}`}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};


/* ─────────────────────────────────────────────────────────────────────────────
   ProductCreate
───────────────────────────────────────────────────────────────────────────── */
const ProductCreate = () => {
  const navigate = useNavigate();
  const sellerId = localStorage.getItem("seller_id");
  const [showBulk, setShowBulk] = useState(false);

  const initialFormState = {
    product_name: "", current_price: "", old_price: "", prod_stock: "",
    rating: "", description: "", product_details: "", prod_vendor_assign: "",
    prod_size: "", status: "", discount_id: "", discount: "", paid_promo: "",
    paid_approval: "", product_status: "", brand_id: "",
    main_category: "", sub_category: "", size_id: [],
    company_name: "", model_name: "", ram: "", rom: "", processor: "",
    camera: "", battery: "", operating_system: "", available_colors: [],
    weight: "", dimension: "",
    fashion_brand_name: "", material: "", fit_type: "", occasion: "",
    available_size: [], available_color: [], care_instructions: "",
    prod_image: null, prod_multi_images: [],
  };

  const [ProductUser, setProductUser]                       = useState(initialFormState);
  const [multiPreview, setMultiPreview]                     = useState([]);
  const [CategoryUser, setCategoryUser]                     = useState([]);
  const [SubCategoryUser, setSubCategoryUser]               = useState([]);
  const [Sizeuser, setSizeUser]                             = useState([]);
  const [ColorUser, setColorUser]                           = useState([]);
  const [DiscountUser, setDiscountUser]                     = useState([]);
  const [BrandUser, setBrandUser]                           = useState([]);
  const [isSizeDropdownOpen, setIsSizeDropdownOpen]         = useState(false);
  const [isColorDropdownOpen, setIsColorDropdownOpen]       = useState(false);
  const [isDiscountDropdownOpen, setIsDiscountDropdownOpen] = useState(false);
  const [isBrandDropdownOpen, setIsBrandDropdownOpen]       = useState(false);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setProductUser(prev => ({ ...prev, [name]: value }));
  };

  const handleSizeCheckbox = (sizeId) => {
    setProductUser(prev => {
      const cur     = prev.size_id || [];
      const idStr   = String(sizeId);
      const updated = cur.includes(idStr) ? cur.filter(x => x !== idStr) : [...cur, idStr];
      return { ...prev, size_id: updated, available_size: updated };
    });
  };

  const handleColorCheckbox = (colorId) => {
    setProductUser(prev => {
      const cur   = prev.available_color || [];
      const idStr = String(colorId);
      return { ...prev, available_color: cur.includes(idStr) ? cur.filter(x => x !== idStr) : [...cur, idStr] };
    });
  };

  const handleBrandRadio = (brandId) => setProductUser(prev => ({ ...prev, brand_id: String(brandId) }));

  const handleMultiImageChange = async (e) => {
    const files = Array.from(e.target.files || []);
    const valid = []; const previews = [];
    for (let file of files) {
      const info = await new Promise((res, rej) => {
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload  = () => res({ width: img.width, height: img.height, isSquare: img.width === img.height });
        img.onerror = () => rej("Invalid image");
      });
      if (!info.isSquare) toast.warning(`${file.name} is ${info.width}×${info.height}. Image will be auto-adjusted.`);
      valid.push(file); previews.push(URL.createObjectURL(file));
    }
    setProductUser(prev => ({ ...prev, prod_multi_images: valid }));
    setMultiPreview(previews);
  };

  useEffect(() => { axios.get(`${API}/list_main_category`).then(r => setCategoryUser(r.data?.row || [])).catch(console.error); }, []);
  useEffect(() => { axios.get(`${API}/list_mst_prod_size`).then(r => setSizeUser(r.data?.row || [])).catch(console.error); }, []);
  useEffect(() => { axios.get(`${API}/list_mst_prod_color`).then(r => setColorUser(r.data?.colors || [])).catch(console.error); }, []);
  useEffect(() => { axios.get(`${API}/discount_list`).then(r => setDiscountUser(r.data?.data || [])).catch(console.error); }, []);
  useEffect(() => { axios.get(`${API}/Brand_list`).then(r => setBrandUser(r.data?.data || [])).catch(console.error); }, []);

  useEffect(() => {
    if (!ProductUser.main_category) { setSubCategoryUser([]); return; }
    axios.get(`${API}/list_main_subcategory`)
      .then(r => setSubCategoryUser((r.data?.row || []).filter(s => String(s.category_id) === String(ProductUser.main_category))))
      .catch(console.error);
  }, [ProductUser.main_category]);

  const submitForm = async (e) => {
    e.preventDefault();
    try {
      const fd = new FormData();
      fd.append("seller_id",       sellerId);
      fd.append("product_name",    (ProductUser.product_name    || "").trim());
      fd.append("current_price",   (ProductUser.current_price   || "").trim());
      fd.append("old_price",       (ProductUser.old_price       || "").trim());
      fd.append("stock",           (ProductUser.prod_stock      || "").trim());
      fd.append("rating",          (ProductUser.rating          || "").trim());
      fd.append("description",     (ProductUser.description     || "").trim());
      fd.append("product_details", (ProductUser.product_details || "").trim());
      fd.append("assign_vendor",   (ProductUser.prod_vendor_assign || "").trim());
      fd.append("size",            (ProductUser.prod_size       || "").trim());
      fd.append("weight",          (ProductUser.weight          || "").trim());
      fd.append("dimension",       (ProductUser.dimension       || "").trim());

      let mappedStatus = "Out of Stock";
      if (ProductUser.status === "Instock")    mappedStatus = "In Stock";
      if (ProductUser.status === "Outofstock") mappedStatus = "Out of Stock";
      if (ProductUser.status === "fewleft")    mappedStatus = "Few Left";
      fd.append("status", mappedStatus);

      fd.append("product_status", ProductUser.product_status || "");
      fd.append("paid_promo",     ProductUser.paid_promo     || "");
      fd.append("paid_approval",  ProductUser.paid_approval  || "");
      fd.append("category_id",    ProductUser.main_category  || "");
      fd.append("subcategory_id", ProductUser.sub_category   || "");
      fd.append("brand_id",       ProductUser.brand_id       || "");
      fd.append("size_id",        Array.isArray(ProductUser.size_id) ? ProductUser.size_id.join(",") : ProductUser.size_id || "");
      fd.append("company_name",     ProductUser.company_name     || "");
      fd.append("model_name",       ProductUser.model_name       || "");
      fd.append("ram",              ProductUser.ram              || "");
      fd.append("rom",              ProductUser.rom              || "");
      fd.append("processor",        ProductUser.processor        || "");
      fd.append("camera",           ProductUser.camera           || "");
      fd.append("battery",          ProductUser.battery          || "");
      fd.append("operating_system", ProductUser.operating_system || "");
      fd.append("fashion_brand_name",  ProductUser.fashion_brand_name  || "");
      fd.append("material",            ProductUser.material            || "");
      fd.append("fit_type",            ProductUser.fit_type            || "");
      fd.append("occasion",            ProductUser.occasion            || "");
      fd.append("available_size",      Array.isArray(ProductUser.available_size) ? ProductUser.available_size.join(",") : ProductUser.available_size || "");
      fd.append("available_color",     Array.isArray(ProductUser.available_color) ? ProductUser.available_color.join(",") : ProductUser.available_color || "");
      fd.append("care_instructions",   ProductUser.care_instructions || "");
      fd.append("discount_id",         ProductUser.discount_id       || "");
      fd.append("discount",            ProductUser.discount          || "");

      if (Array.isArray(ProductUser.prod_multi_images) && ProductUser.prod_multi_images.length)
        ProductUser.prod_multi_images.forEach(file => fd.append("multi_image[]", file));

      const res  = await axios.post(`${API}/add_create_product`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      const data = res.data;
      const ok   = data?.status === true || data?.success === "1" || data?.status === "true";
      if (ok) {
        toast.success(data?.message || "Product added successfully!");
        setProductUser(initialFormState); setMultiPreview([]);
        navigate("/product-list");
      } else {
        toast.error(data?.message || "Failed to add product");
      }
    } catch (err) {
      console.error("API Error:", err);
      toast.error("Something went wrong!");
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">

        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box d-flex align-items-center justify-content-between flex-wrap gap-2">
              <div>
                <h4 className="mb-0 fw-semibold">Create Product</h4>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">Product</li>
                  <li className="breadcrumb-item active">Create Product</li>
                </ol>
              </div>
              <button type="button" className="btn btn-outline-primary d-flex align-items-center gap-2"
                onClick={() => setShowBulk(true)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>
                  <path d="M8 6.5a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 10.793V7a.5.5 0 0 1 .5-.5z"/>
                </svg>
                Bulk Import via Excel
              </button>
            </div>
          </div>
        </div>

        <BulkImportModal show={showBulk} onClose={() => setShowBulk(false)} sellerId={sellerId} />

        <div className="row">
          <div className="col-xl-9 col-lg-8">
            <form onSubmit={submitForm}>

              {/* Images */}
              <div className="card mb-3">
                <div className="card-header"><h4 className="card-title">Add Product Photo</h4></div>
                <div className="card-body">
                  <label className="form-label text-dark">Product Multiple Images</label>
                  <input type="file" multiple className="form-control" accept=".png,.webp" onChange={handleMultiImageChange} />
                  <small className="text-muted d-block mt-1">
                    Recommended: <b>2000×2000 px (1:1)</b> · Formats: <b>.webp, .png</b> · Max 500 KB/image
                  </small>
                  <div className="d-flex gap-2 mt-2">
                    {multiPreview.map((p, i) => <img key={i} src={p} alt={`multi-${i}`} className="product-preview" />)}
                  </div>
                </div>
              </div>

              {/* Product Info */}
              <div className="card">
                <div className="card-header"><h4 className="card-title">Product Information</h4></div>
                <div className="card-body">
                  <div className="row g-3">

                    <div className="col-lg-6">
                      <label className="form-label">Product Name</label>
                      <input type="text" name="product_name" value={ProductUser.product_name}
                        onChange={handleInput} className="form-control" placeholder="Enter product name" />
                    </div>
                    <div className="col-lg-6">
                      <label className="form-label">Current Price</label>
                      <input type="number" name="current_price" value={ProductUser.current_price}
                        onChange={handleInput} className="form-control" placeholder="000" />
                    </div>
                    <div className="col-lg-6">
                      <label className="form-label">Old Price</label>
                      <input type="number" name="old_price" value={ProductUser.old_price}
                        onChange={handleInput} className="form-control" placeholder="000" />
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Main Category</label>
                      <select className="form-control" name="main_category" value={ProductUser.main_category}
                        onChange={e => setProductUser(prev => ({ ...prev, main_category: e.target.value, sub_category: "" }))}>
                        <option value="">-- Select Main Category --</option>
                        {CategoryUser.map(item => (
                          <option key={item.category_id} value={String(item.category_id)}>{item.category_name}</option>
                        ))}
                      </select>
                    </div>

                    {ProductUser.main_category && (
                      <div className="col-lg-6">
                        <label className="form-label">Subcategory</label>
                        <select className="form-control" name="sub_category" value={ProductUser.sub_category} onChange={handleInput}>
                          <option value="">-- Select Subcategory --</option>
                          {SubCategoryUser.map(item => (
                            <option key={item.subcategory_id} value={String(item.subcategory_id)}>{item.subcategory_name}</option>
                          ))}
                        </select>
                      </div>
                    )}

                    {/* Brand */}
                    <div className="col-lg-6">
                      <label className="form-label">Product Brand</label>
                      <div className="position-relative">
                        <div className="form-control d-flex justify-content-between align-items-center"
                          style={{ cursor: "pointer" }} onClick={() => setIsBrandDropdownOpen(!isBrandDropdownOpen)}>
                          <span>{ProductUser.brand_id
                            ? BrandUser.find(b => String(b.brand_id) === String(ProductUser.brand_id))?.brand_name || "Select brand"
                            : "Select brand"}</span>
                          <span>{isBrandDropdownOpen ? "▲" : "▼"}</span>
                        </div>
                        {isBrandDropdownOpen && (
                          <div className="border rounded bg-white position-absolute w-100 mt-1"
                            style={{ maxHeight: 250, overflowY: "auto", zIndex: 1000, boxShadow: "0 2px 8px rgba(0,0,0,.15)" }}>
                            <div className="p-3">
                              {BrandUser.filter(b => b.status === "active").map(brand => (
                                <div key={brand.brand_id} className="form-check mb-2">
                                  <input className="form-check-input" type="radio" name="brand_selection"
                                    id={`brand-${brand.brand_id}`}
                                    checked={String(ProductUser.brand_id) === String(brand.brand_id)}
                                    onChange={() => { handleBrandRadio(brand.brand_id); setIsBrandDropdownOpen(false); }} />
                                  <label className="form-check-label" htmlFor={`brand-${brand.brand_id}`}>
                                    <div className="fw-semibold">{brand.brand_name}</div>
                                    <small className="text-muted">{brand.manuf_name}</small>
                                  </label>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Sizes */}
                    <div className="col-lg-6">
                      <label className="form-label">Product Sizes</label>
                      <div className="position-relative">
                        <div className="form-control d-flex justify-content-between align-items-center"
                          style={{ cursor: "pointer" }} onClick={() => setIsSizeDropdownOpen(!isSizeDropdownOpen)}>
                          <span>{ProductUser.size_id?.length > 0 ? `${ProductUser.size_id.length} size(s) selected` : "Select sizes"}</span>
                          <span>{isSizeDropdownOpen ? "▲" : "▼"}</span>
                        </div>
                        {isSizeDropdownOpen && (
                          <div className="border rounded bg-white position-absolute w-100 mt-1"
                            style={{ maxHeight: 200, overflowY: "auto", zIndex: 1000, boxShadow: "0 2px 8px rgba(0,0,0,.15)" }}>
                            <div className="p-3">
                              {Sizeuser.map(size => (
                                <div key={size.size_id} className="form-check mb-2">
                                  <input className="form-check-input" type="checkbox"
                                    id={`size-${size.size_id}`}
                                    checked={(ProductUser.size_id || []).includes(String(size.size_id))}
                                    onChange={() => handleSizeCheckbox(size.size_id)} />
                                  <label className="form-check-label" htmlFor={`size-${size.size_id}`}>
                                    {size.size_label || size.size}
                                  </label>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Colors */}
                    <div className="col-lg-6">
                      <label className="form-label">Product Colors</label>
                      <div className="position-relative">
                        <div className="form-control d-flex justify-content-between align-items-center"
                          style={{ cursor: "pointer" }} onClick={() => setIsColorDropdownOpen(!isColorDropdownOpen)}>
                          <span>{ProductUser.available_color?.length > 0 ? `${ProductUser.available_color.length} color(s) selected` : "Select colors"}</span>
                          <span>{isColorDropdownOpen ? "▲" : "▼"}</span>
                        </div>
                        {isColorDropdownOpen && (
                          <div className="border rounded bg-white position-absolute w-100 mt-1"
                            style={{ maxHeight: 200, overflowY: "auto", zIndex: 1000, boxShadow: "0 2px 8px rgba(0,0,0,.15)" }}>
                            <div className="p-3">
                              {ColorUser.map(color => (
                                <div key={color.color_id} className="form-check mb-2 d-flex align-items-center">
                                  <input className="form-check-input" type="checkbox"
                                    id={`color-${color.color_id}`}
                                    checked={(ProductUser.available_color || []).includes(String(color.color_id))}
                                    onChange={() => handleColorCheckbox(color.color_id)} />
                                  <label className="form-check-label d-flex align-items-center" htmlFor={`color-${color.color_id}`}>
                                    <span className="d-inline-block me-2 ms-2"
                                      style={{ width: 20, height: 20, backgroundColor: color.code, border: "1px solid #ddd", borderRadius: 3 }} />
                                    {color.color_name}
                                  </label>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Electronics */}
                    {String(ProductUser.main_category) === "1" && (
                      <>
                        <hr className="mt-4 mb-2" /><h5 className="text-primary">Electronics Specifications</h5>
                        <div className="col-lg-6">
                          <label className="form-label">Company Name</label>
                          <input type="text" name="company_name" value={ProductUser.company_name}
                            onChange={handleInput} className="form-control" placeholder="e.g. Apple" />
                        </div>
                        <div className="col-lg-6">
                          <label className="form-label">Model Name</label>
                          <input type="text" name="model_name" value={ProductUser.model_name}
                            onChange={handleInput} className="form-control" placeholder="e.g. iPhone 16" />
                        </div>
                        <div className="col-12">
                          <label className="form-label">Specifications</label>
                          <div className="row g-3">
                            {[["ram","RAM"],["rom","ROM"],["processor","Processor"],["camera","Camera"],["battery","Battery (mAh)"],["operating_system","Operating System"]].map(([name, ph]) => (
                              <div className="col-lg-4" key={name}>
                                <input type="text" name={name} value={ProductUser[name]}
                                  onChange={handleInput} className="form-control" placeholder={ph} />
                              </div>
                            ))}
                          </div>
                        </div>
                      </>
                    )}

                    {/* Fashion */}
                    {String(ProductUser.main_category) === "2" && (
                      <>
                        <hr className="mt-4 mb-2" /><h5 className="text-primary">Fashion Specifications</h5>
                        {[["fashion_brand_name","Brand Name","e.g. Levi's"],["material","Material","e.g. Cotton"],
                          ["fit_type","Fit Type","e.g. Regular Fit"],["occasion","Occasion","e.g. Casual"],
                          ["care_instructions","Care Instructions","e.g. Machine wash cold"]].map(([name, label, ph]) => (
                          <div className="col-lg-6" key={name}>
                            <label className="form-label">{label}</label>
                            <input type="text" name={name} value={ProductUser[name]}
                              onChange={handleInput} className="form-control" placeholder={ph} />
                          </div>
                        ))}
                      </>
                    )}

                    <div className="col-lg-6">
                      <label className="form-label">Stock</label>
                      <input type="text" name="prod_stock" value={ProductUser.prod_stock}
                        onChange={handleInput} className="form-control" placeholder="Enter stock quantity" />
                    </div>
                    <div className="col-lg-6">
                      <label className="form-label">Rating</label>
                      <input type="text" name="rating" value={ProductUser.rating}
                        onChange={handleInput} className="form-control" placeholder="e.g. 4.5" />
                    </div>

                    {/* Discount */}
                    <div className="col-lg-6">
                      <label className="form-label">Apply Discount</label>
                      <div className="position-relative">
                        <div className="form-control d-flex justify-content-between align-items-center"
                          style={{ cursor: "pointer" }} onClick={() => setIsDiscountDropdownOpen(!isDiscountDropdownOpen)}>
                          <span>{ProductUser.discount_id
                            ? DiscountUser.find(d => String(d.disc_id) === String(ProductUser.discount_id))?.disc_name
                            : "Select discount"}</span>
                          <span>{isDiscountDropdownOpen ? "▲" : "▼"}</span>
                        </div>
                        {isDiscountDropdownOpen && (
                          <div className="border rounded bg-white position-absolute w-100 mt-1"
                            style={{ maxHeight: 250, overflowY: "auto", zIndex: 1000, boxShadow: "0 2px 8px rgba(0,0,0,.15)" }}>
                            <div className="p-2">
                              <div className="p-2" style={{ cursor: "pointer" }}
                                onClick={() => { setProductUser(p => ({ ...p, discount_id: "", discount: "" })); setIsDiscountDropdownOpen(false); }}>
                                <small className="text-muted">No Discount</small>
                              </div>
                              {DiscountUser.filter(d => d.status === "1").map(item => (
                                <div key={item.disc_id} className="p-2 border-bottom" style={{ cursor: "pointer" }}
                                  onClick={() => { setProductUser(p => ({ ...p, discount_id: item.disc_id, discount: item.disc_amount })); setIsDiscountDropdownOpen(false); }}>
                                  <div className="d-flex justify-content-between align-items-start">
                                    <div>
                                      <div className="fw-semibold">{item.disc_name}</div>
                                      <small className="text-muted">{item.disc_start_date} to {item.disc_end_date}</small>
                                    </div>
                                    <span className="badge bg-success">₹{item.disc_amount} OFF</span>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Description</label>
                      <input type="text" name="description" value={ProductUser.description}
                        onChange={handleInput} className="form-control" placeholder="Short product description" />
                    </div>
                    <div className="col-lg-6">
                      <label className="form-label">Product Details</label>
                      <input type="text" name="product_details" value={ProductUser.product_details}
                        onChange={handleInput} className="form-control" placeholder="Additional details" />
                    </div>
                    <div className="col-lg-6">
                      <label className="form-label">Weight</label>
                      <input type="text" name="weight" value={ProductUser.weight}
                        onChange={handleInput} className="form-control" placeholder="Enter weight" />
                    </div>
                    <div className="col-lg-6">
                      <label className="form-label">Dimension</label>
                      <input type="text" name="dimension" value={ProductUser.dimension}
                        onChange={handleInput} className="form-control" placeholder="Enter Dimension" />
                    </div>
                    <div className="col-lg-6">
                      <label className="form-label">Assign Vendor</label>
                      <select className="form-control" name="prod_vendor_assign"
                        value={ProductUser.prod_vendor_assign} onChange={handleInput}>
                        <option value="">Select Vendor</option>
                        <option value="H&M">H&M</option>
                        <option value="Nike">Nike</option>
                        <option value="Zara">Zara</option>
                      </select>
                    </div>
                    <div className="col-lg-6">
                      <label className="form-label">Product Status</label>
                      <select className="form-control" name="product_status"
                        value={ProductUser.product_status} onChange={handleInput}>
                        <option value="">-- None --</option>
                        {["Top Deals","Fashion Top Deals","Shop Your Favorites","Special Offers",
                          "Grand Global Brand","Shop By Category","Top Pick of the sale",
                          "Crazy Deals","Products for you","Groceries"].map(v => (
                          <option key={v} value={v}>{v}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-lg-6">
                      <label className="form-label">Paid Promotion</label>
                      <select className="form-control" name="paid_promo"
                        value={ProductUser.paid_promo} onChange={handleInput}>
                        <option value="">-- Select Paid Promotion --</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div>
                    <div className="col-lg-6">
                      <label className="form-label">Paid Promotion Approval</label>
                      <select className="form-control" name="paid_approval"
                        value={ProductUser.paid_approval} onChange={handleInput}>
                        <option value="">-- Select Paid Promotion Approval --</option>
                        <option value="yes">Approve</option>
                        <option value="no">Reject</option>
                      </select>
                    </div>
                    <div className="col-lg-6">
                      <label className="form-label">Status</label>
                      <select className="form-control" name="status"
                        value={ProductUser.status} onChange={handleInput}>
                        <option value="">-- Select Status --</option>
                        <option value="Instock">In stock</option>
                        <option value="Outofstock">Out of stock</option>
                        <option value="fewleft">Few left</option>
                      </select>
                    </div>

                  </div>
                </div>
              </div>

              <div className="p-3 bg-light mb-3 rounded">
                <div className="row justify-content-end g-2">
                  <div className="col-lg-2">
                    <button type="submit" className="btn btn-outline-secondary w-100">Create Product</button>
                  </div>
                  <div className="col-lg-2">
                    <Link to="/product-list" className="btn btn-primary w-100">Cancel</Link>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <footer className="footer">
        <div className="container-fluid text-center py-3">
          © Venton. Crafted by <span className="text-danger">❤️</span> <strong>Techzaa</strong>
        </div>
      </footer>
    </div>
  );
};

export default ProductCreate;